import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileXls.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "FileXlsIcon";
const m = o;
export {
  m as FileXls,
  o as FileXlsIcon
};
